module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.doctypes), function(doctype) {
    return _c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "col-7 col-md-12"
    }, [_c('div', {
      staticClass: "panel-header"
    }, [_c('div', {
      staticClass: "panel-title h5"
    }, [_vm._v(_vm._s(doctype.name))]), _vm._v(" "), (doctype.helptext) ? _c('div', {
      staticClass: "tooltipz",
      domProps: {
        "innerHTML": _vm._s(doctype.helptext)
      }
    }) : _vm._e(), _vm._v(" "), _c('upload', {
      attrs: {
        "matter": _vm.matter,
        "doctype": doctype
      },
      on: {
        "new": _vm.addFile
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "panel-body"
    }, _vm._l((_vm.files[doctype.ref]), function(file, index) {
      return _c('file-item', {
        key: file.id,
        attrs: {
          "file": file,
          "matter": _vm.matter
        },
        on: {
          "deleted": function($event) {
            return _vm.delFile(doctype.ref, index)
          }
        }
      })
    }), 1)])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9e472ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/matterDocs.vue
// module id = 521
// module chunks = 1